import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Box, CircularProgress, useTheme } from "@mui/material";

interface PanelListProps {
  isLoading: boolean;
  isEmpty: boolean;
  children: ReactNode;
}

export default function PanelList({
  isLoading,
  isEmpty,
  children,
}: PanelListProps) {
  const { t } = useTranslation("my-space");
  const theme = useTheme();

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isEmpty) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          py: 4,
          color: theme.palette.text.tertiary,
          fontSize: "13px",
        }}
      >
        {t("empty")}
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {children}
    </Box>
  );
}
